import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
/**
 * Generic RSA Encryption Utility
 * Reusable RSA encryption service that can be used across different parts of the application
 *
 * @version 1.0.0
 * @author Syarah Team
 */

/**
 * Generic RSA Encryption Service
 */
export var RSAEncryption = /*#__PURE__*/function () {
  /**
   * Constructor with injectable public key
   */
  function RSAEncryption(publicKey) {
    _classCallCheck(this, RSAEncryption);
    _defineProperty(this, "isInitialized", false);
    _defineProperty(this, "cryptoKey", null);
    this.publicKey = publicKey;
  }

  /**
   * Initialize the encryption service
   */
  return _createClass(RSAEncryption, [{
    key: "initialize",
    value: (function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.isInitialized || !this.publicKey)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.importPublicKey(this.publicKey);
            case 2:
              this.cryptoKey = _context.v;
              this.isInitialized = true;
              console.log('[RSAEncryption] Service initialized successfully');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('[RSAEncryption] Failed to initialize:', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Convert PEM to CryptoKey for browser
     */
    )
  }, {
    key: "importPublicKey",
    value: (function () {
      var _importPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(pem) {
        var pemContents, binaryDer;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // Clean up the PEM string
              pemContents = pem.replace(/-----BEGIN PUBLIC KEY-----/g, '').replace(/-----END PUBLIC KEY-----/g, '').replace(/-----BEGIN RSA PUBLIC KEY-----/g, '').replace(/-----END RSA PUBLIC KEY-----/g, '').replace(/\\n/g, '') // Handle escaped newlines
              .replace(/\n/g, '') // Handle actual newlines
              .replace(/\s/g, ''); // Convert base64 to binary
              binaryDer = Uint8Array.from(atob(pemContents), function (c) {
                return c.charCodeAt(0);
              }); // Import the key
              _context2.n = 1;
              return crypto.subtle.importKey('spki', binaryDer, {
                name: 'RSA-OAEP',
                hash: 'SHA-256'
              }, false, ['encrypt']);
            case 1:
              return _context2.a(2, _context2.v);
          }
        }, _callee2);
      }));
      function importPublicKey(_x) {
        return _importPublicKey.apply(this, arguments);
      }
      return importPublicKey;
    }()
    /**
     * Encrypt sensitive data (phone numbers, emails, etc.)
     */
    )
  }, {
    key: "encrypt",
    value: (function () {
      var _encrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
        var encoder, encodedData, encrypted, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (data) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, null);
            case 1:
              if (this.isInitialized) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return this.initialize();
            case 2:
              if (this.cryptoKey) {
                _context3.n = 3;
                break;
              }
              console.warn('[RSAEncryption] No crypto key available');
              return _context3.a(2, null);
            case 3:
              _context3.p = 3;
              encoder = new TextEncoder();
              encodedData = encoder.encode(data);
              _context3.n = 4;
              return crypto.subtle.encrypt({
                name: 'RSA-OAEP'
              }, this.cryptoKey, encodedData);
            case 4:
              encrypted = _context3.v;
              return _context3.a(2, btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(encrypted)))));
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              console.error('[RSAEncryption] Encryption failed:', _t2);
              return _context3.a(2, null);
          }
        }, _callee3, this, [[3, 5]]);
      }));
      function encrypt(_x2) {
        return _encrypt.apply(this, arguments);
      }
      return encrypt;
    }())
  }]);
}();
export default RSAEncryption;